export const UNNAMED_INVESTOR_LABEL = 'Unnamed investor';

type InvestorNameFields = {
  name?: string | null;
};

type InvestorOptionFields = InvestorNameFields & {
  id: string;
  email?: string | null;
};

export const normalizeInvestorNamePart = (value?: string | null) => {
  const trimmedValue = value?.trim();
  return trimmedValue ? trimmedValue : null;
};

export const getInvestorNameOrFallback = (name?: string | null) =>
  normalizeInvestorNamePart(name) ?? UNNAMED_INVESTOR_LABEL;

export const getInvestorDisplayName = (investor: InvestorNameFields) =>
  getInvestorNameOrFallback(investor.name);

export const getInvestorOptionLabel = (investor: InvestorOptionFields) => {
  const displayName = getInvestorDisplayName(investor);

  if (displayName !== UNNAMED_INVESTOR_LABEL) {
    return displayName;
  }

  const secondaryIdentifier = normalizeInvestorNamePart(investor.email) ?? investor.id;

  return `${displayName} (${secondaryIdentifier})`;
};
